<template>
	<div class="hot">
		<div class="hot_top">
			<div class="user">
				<img :src="this.$store.state.user.avatar" />
				<div class="user_info">
					<div class="username">
						{{ this.$store.state.user.name }}
					</div>
					<div class="uid">ID:{{ this.$store.state.user.uid }}</div>
				</div>
				<div class="top_btn" @click="jumpExchangeRecord">兑换记录</div>
			</div>
		</div>
		<div class="user_points">
			<div class="user_all_points">
				<font class="points_value">{{
					$store.state.user.left_points
				}}</font>
				<font class="points_name">分</font>
			</div>
			<div class="user_last_points">
				<font>昨日新增</font>
				<font class="points_value">{{
					$store.state.user.last_points
				}}</font>
				<font class="points_name">分</font>
			</div>
		</div>
		<div class="switchBox">
			<span
				:class="{ left: true, active: switchFlag }"
				@click="changeSwitchFlag(1)"
				>昨日排行</span
			>
			<span
				:class="{ right: true, active: !switchFlag }"
				@click="changeSwitchFlag(0)"
				>3日排行</span
			>
		</div>
		<div class="hotAvatarBg">
			<div class="hotAvatarBgWrap">
				<div class="honor2Wrap">
					<div class="honor2">
						<!--            <img :src="list[1].avatar">-->
						<img
							:src="
								list[1].avatar
									? list[1].avatar
									: home_user_unlogin_avatar
							"
						/>
					</div>
					<div class="honor22">NO.2</div>
					<div class="text1">{{ list[1].name }}</div>
					<div class="text2">{{ list[1].points }}分</div>
				</div>

				<div class="honor1Wrap">
					<div class="honor2">
						<!--            <img :src="list[0].avatar">-->
						<img
							:src="
								list[0].avatar
									? list[0].avatar
									: home_user_unlogin_avatar
							"
						/>
					</div>
					<div class="honor22">NO.1</div>
					<!--          <div class="text1">**{{list[0].uid.substring(list[0].uid.length-2)}}</div>-->
					<div class="text1">{{ list[0].name }}</div>
					<div class="text2">{{ list[0].points }}分</div>
				</div>

				<div class="honor3Wrap">
					<div class="honor2">
						<!--            <img :src="list[2].avatar">-->
						<img
							:src="
								list[2].avatar
									? list[2].avatar
									: home_user_unlogin_avatar
							"
						/>
					</div>
					<div class="honor22">NO.3</div>
					<div class="text1">{{ list[2].name }}</div>
					<div class="text2">{{ list[2].points }}分</div>
				</div>
			</div>
		</div>

		<div class="honorList">
			<div class="honorWrap">
				<div class="line lineHead">
					<div class="text1 extra">排名</div>
					<div class="text2 extra">名称</div>
					<div class="text3 extra">积分</div>
				</div>
				<div
					class="line lineContent"
					:key="item.text"
					v-for="(item, index) in startWith3"
				>
					<div class="text1">{{ index + 4 }}</div>
					<div class="text2">{{ item.name }}</div>
					<div class="text3">{{ item.points }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";

export default {
	name: "hot",
	components: {},
	data: function () {
		return {
			hot_text: require("../assets/mall/hot_text.svg"),
			hot_hat: require("../assets/mall/hot_hat.png"),
			home_user_unlogin_avatar: require("../assets/mall/home_user_unlogin_avatar.png"),
			switchFlag: true,
			list: [
				{
					avatar: "",
					name: "",
					points: 0,
				},
				{
					avatar: "",
					name: "",
					points: 0,
				},
				{
					avatar: "",
					name: "",
					points: 0,
				},
			],
		};
	},
	computed: {
		startWith3() {
			return this.list.slice(3);
		},
	},
	watch: {
		isShowErrTips: function (newVal) {
			let _that = this;
			if (newVal) {
				setTimeout(function () {
					_that.isShowErrTips = false;
				}, 1500);
			}
		},
		switchFlag: function (newVal) {
			let _that = this;
			if (newVal) {
				_that.getTodayList();
			} else {
				_that.getThreeDaysList();
			}
		},
	},
	methods: {
		...mapActions(["todayList", "threeDaysList"]),
		jumpExchangeRecord: function () {
			this.$router.push({
				path: "/home/mall/record",
			});
		},
		showPointsTips: function () {
			let _that = this;
			_that.$store.state.isShowPointsTips = true;
		},
		switchIt: function () {
			let _that = this;
			_that.switchFlag = !_that.switchFlag;
		},
		changeSwitchFlag: function (switchFlag) {
			let _that = this;
			_that.switchFlag = switchFlag;
		},
		goBack: function () {
			this.$router.back(-1);
		},
		getTodayList: function () {
			let _that = this;
			this.todayList([
				function (err, data) {
					if (err) {
						return err;
					}
					// console.log(JSON.stringify(data));
					for (let index = 0; index < data.data.length; index++) {
						const element = data.data[index];
						element.avatar = _that.http2Https(element.avatar);
					}
					_that.list = data.data;
				},
			]);
		},
		getThreeDaysList: function () {
			let _that = this;
			this.threeDaysList([
				function (err, data) {
					if (err) {
						return err;
					}
					// console.log(JSON.stringify(data));
					for (let index = 0; index < data.data.length; index++) {
						const element = data.data[index];
						element.avatar = _that.http2Https(element.avatar);
					}
					_that.list = data.data;
				},
			]);
		},
		http2Https: function (src) {
			if (!src) {
				return src;
			}
			let arr = src.split("://");
			if (arr.length > 1 && arr[0] == "http") {
				//跳转到https跳转到http
				src = "https://" + arr[1];
			}
			return src;
		},
	},
	mounted: function () {
		this.getTodayList();
	},
};
</script>

<style lang="less" scoped>
.hot {
	width: 100%;
	min-height: 100%;
	height: 100%;
	// background-image: linear-gradient(to bottom, #fef1db, #fae0b0);
	background-color: #324b84;
	background-image: linear-gradient(to bottom, #395799, #1a2f64);

	.hot_top {
		.user {
			align-items: center;
			border-bottom: 1px solid #ecf5ff;
			width: 247px;
			margin-left: 15px;
			padding: 5px 0;

			img {
				display: inline-block;
				margin-right: 7px;
				width: 31px;
				height: 31px;
				border-radius: 31px;
				border: 1px solid #f8cb6c;
				vertical-align: top;
			}
			.user_info {
				display: inline-block;
				width: 140px;
				vertical-align: top;
			}

			.username {
				color: #ffffff;
				font-weight: bold;
				font-size: 12px;
				margin-top: 1px;
			}

			.uid {
				color: #ffffff;
				font-size: 12px;
				transform: scale(0.75);
				transform-origin: left center;
				// margin-left: -6px;
				// margin-top: -2px;
			}
			.top_btn {
				width: 60px;
				height: 22px;
				line-height: 22px;
				font-size: 12px;
				display: inline-block;
				vertical-align: top;
				color: #fcc11a;
				border: 1px solid #fcc11a;
				border-radius: 12px;
				text-align: center;
				margin-top: 5px;
			}
			.top_btn:hover {
				opacity: 0.8;
				cursor: pointer;
			}
		}
	}

	.backBtn {
		margin-top: 5px;
		margin-left: 5px;
		cursor: pointer;
	}

	.hotText {
		width: 200px;
		height: 88px;
		background-image: url(../assets/mall/hot_text.svg);
		background-repeat: no-repeat;
		background-size: 100% 100%;

		img {
			position: absolute;
			top: 22px;
			right: 42px;
			width: 22px;
			height: 13px;
		}
	}

	.switchBox {
		position: relative;
		margin: 0 auto;
		margin-top: 15px;
		width: 200px;
		height: 26px;
		line-height: 26px;
		text-align: center;
		box-sizing: border-box;
		//border-radius: 12px;
		z-index: 1;

		.left,
		.right {
			//display: inline-block;
			color: #666666;
			font-size: 13px;
			width: 50%;
			height: 100%;
			box-sizing: border-box;
			background-color: #eeeeee;
			// border: 1px solid #efd093;
		}

		.left {
			position: absolute;
			top: 0;
			left: 0;
			z-index: 2;
			border-top-left-radius: 12px;
			border-bottom-left-radius: 12px;
		}
		.right {
			position: absolute;
			top: 0;
			right: 0;
			z-index: 2;
			border-top-right-radius: 12px;
			border-bottom-right-radius: 12px;
		}
		.active {
			color: #ffffff;
			background-color: #314a84;
			border: 1px solid #ffffff;
		}
		.left:hover,
		.right:hover {
			cursor: pointer;
			opacity: 0.9;
		}
	}

	.hotAvatarBg {
		width: 94%;
		margin-left: 3%;
		height: 205px;
		margin-top: -40px;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		box-sizing: border-box;

		.hotAvatarBgWrap {
			position: relative;
			width: 100%;
			height: 100%;
			box-sizing: border-box;

			.honor2Wrap {
				position: absolute;
				top: 65px;
				width: 85px;

				.honor2 {
					position: relative;
					margin: 0 auto;
					width: 54px;
					height: 70px;
					background-image: url(../assets/mall/hot_honor2.png);
					background-repeat: no-repeat;
					background-size: 100% 100%;

					img {
						position: absolute;
						left: 50%;
						bottom: 2.5px;
						transform: translate(-50%, 0);
						width: 51px;
						height: 50px;
						border-radius: 50px;
					}
				}
				.honor22 {
					position: absolute;
					top: 62px;
					width: 85px;
					height: 25px;
					font-size: 12px;
					text-align: center;
					line-height: 25px;
					color: #ffffff;
					background-image: url(../assets/mall/hot_honor22.png);
					background-repeat: no-repeat;
					background-size: 100% 100%;
				}

				.text1 {
					white-space: nowrap; //   强制在同一行内显示所有文本
					overflow: hidden; //多余的内容隐藏掉
					text-overflow: ellipsis; // 溢出的部分显示省略号
					margin-top: 20px;
					text-align: center;
					font-size: 12px;
					color: #ffffff;
				}

				.text2 {
					text-align: center;
					font-size: 12px;
					color: #ff8d00;
				}
			}

			.honor1Wrap {
				position: absolute;
				top: 55px;
				left: 50%;
				transform: translate(-50%, 0);
				width: 85px;

				.honor2 {
					position: relative;
					margin: 0 auto;
					width: 54px;
					height: 70px;
					background-image: url(../assets/mall/hot_honor1.png);
					background-repeat: no-repeat;
					background-size: 100% 100%;

					img {
						position: absolute;
						left: 50%;
						bottom: 2.5px;
						transform: translate(-50%, 0);
						width: 51px;
						height: 50px;
						border-radius: 50px;
					}
				}
				.honor22 {
					position: absolute;
					top: 62px;
					width: 85px;
					height: 25px;
					font-size: 12px;
					text-align: center;
					line-height: 25px;
					color: #fff;
					background-image: url(../assets/mall/hot_honor11.png);
					background-repeat: no-repeat;
					background-size: 100% 100%;
				}

				.text1 {
					white-space: nowrap; //   强制在同一行内显示所有文本
					overflow: hidden; //多余的内容隐藏掉
					text-overflow: ellipsis; // 溢出的部分显示省略号
					margin-top: 20px;
					text-align: center;
					font-size: 12px;
					color: #ffffff;
				}

				.text2 {
					text-align: center;

					font-size: 12px;
					color: #ff8d00;
				}
			}

			.honor3Wrap {
				position: absolute;
				top: 65px;
				right: 0px;
				width: 85px;

				.honor2 {
					position: relative;
					margin: 0 auto;
					width: 54px;
					height: 70px;
					background-image: url(../assets/mall/hot_honor3.png);
					background-repeat: no-repeat;
					background-size: 100% 100%;

					img {
						position: absolute;
						left: 50%;
						bottom: 2.5px;
						transform: translate(-50%, 0);
						width: 51px;
						height: 50px;
						border-radius: 50px;
					}
				}
				.honor22 {
					position: absolute;
					top: 62px;
					width: 85px;
					height: 25px;
					font-size: 12px;
					text-align: center;
					line-height: 25px;
					color: #fff;
					background-image: url(../assets/mall/hot_honor33.png);
					background-repeat: no-repeat;
					background-size: 100% 100%;
				}

				.text1 {
					white-space: nowrap; //   强制在同一行内显示所有文本
					overflow: hidden; //多余的内容隐藏掉
					text-overflow: ellipsis; // 溢出的部分显示省略号
					margin-top: 20px;
					text-align: center;
					font-size: 12px;
					color: #ffffff;
				}

				.text2 {
					text-align: center;
					font-size: 12px;
					color: #ff8d00;
				}
			}
		}
	}

	.honorList::-webkit-scrollbar {
		display: none;
	}

	.honorList {
		flex: 1;
		width: 250px;
		height: 160px;
		margin-left: 12px;
		border-radius: 5px;
		//min-height: 300px;
		//max-height: 320px;
		background-color: #ebf5ff;
		overflow-y: scroll;
		overflow-x: hidden;
		-ms-overflow-style: none;
		scrollbar-width: none;
		font-size: 12px;

		.honorWrap {
			padding: 0 12px;
			background-color: rgba(249, 249, 249, 0.03);
		}

		.honorWrap > div:last-child {
			border-bottom: none;
		}

		.line {
			height: 32px;
			line-height: 32px;
			box-sizing: border-box;
			text-align: center;

			.text1 {
				width: 20%;
				color: #666666;
				display: inline-block;
				vertical-align: top;
			}
			.text2 {
				//padding-left: 20px;
				white-space: nowrap; //   强制在同一行内显示所有文本
				overflow: hidden; //多余的内容隐藏掉
				text-overflow: ellipsis; // 溢出的部分显示省略号
				color: #666666;
				width: 60%;
				display: inline-block;
				vertical-align: top;
			}
			.text3 {
				//padding-left: 50px;
				color: #ff8d00;
				width: 20%;
				box-sizing: border-box;
				display: inline-block;
				vertical-align: top;
			}
			.extra {
				color: #666666;
			}
		}

		.lineContent {
			border-bottom: 1px solid rgba(119, 135, 216, 0.1);
		}

		.lineHead {
			height: 32px;
			line-height: 32px;
			color: #666666;
			box-sizing: border-box;
			border-bottom: 1px solid rgba(119, 135, 216, 0.2);
		}
	}
}

.user_points {
	.user_all_points {
		text-align: center;
		margin-top: 20px;
		font-size: 41px;
		color: #fcc01a;
		.points_name {
			color: #fcc01a;
			font-size: 12px;
			vertical-align: normal;
			margin-left: 4px;
		}
	}
	.user_last_points {
		font-size: 12px;
		text-align: center;
		color: #cccccc;
		.points_value {
			color: #fcc01a;
			margin-left: 4px;
		}
		.points_name {
			color: #fcc01a;
			font-size: 12px;
			vertical-align: normal;
		}
	}
}

.home_point_tips_btn {
	height: 28px;
	width: 110px;
	line-height: 28px;
	margin: 0 auto;
	margin-top: 10px;
	margin-bottom: 10px;
	background-color: #ffea97;
	border-radius: 14px;
	color: #ac520d;
	font-size: 12px;
	padding: 0 15px;
	text-align: center;
	box-shadow: 0px 0px 4px #555555;
	cursor: pointer;
}

.home_point_tips_btn_pc {
	//margin-top: 25px;
}
</style>